import React, { Fragment } from 'react'
import {
    Edit,
    TextInput,
    BooleanInput,
    NumberInput
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

export const CategoriaVUEdit = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    return (
        <Fragment>
            <Title title={"Editar Categoria Vida Útil"} />
            <Edit {...props}>
                <CustomSimpleForm>
                    <NumberInput source="id" disabled={true} />
                    <TextInput source="name" />
                    <TextInput source="description" />
                    <NumberInput source="vida_util" />
                    <BooleanInput source="active" />
                </CustomSimpleForm>
            </Edit>
        </Fragment>
    )
};

